import BaseComponent from "../../baseComponent.js";
import styles from "./add-widget.scss";

export default class Title extends BaseComponent {
  constructor(props) {
    super(props);
  }

  onTitleChange(event) {
    this.props.handleTitleChange(event.target.value);
  }

  render() {
    return (
      <div className={["input-field", styles.title].join(" ")}>
        <input type="text" placeholder="TITLE"
               value={this.props.title} ref="titleTextInput" onChange={this.onTitleChange}/>
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/components/dashboard/add-widget/title.jsx